// EarthMassCalculator.js
import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Kalkulator Massa Bumi - Hitung Massa Menggunakan Hukum Gravitasi Universal";
const DESCRIPTION =
  "Gunakan kalkulator massa Bumi canggih untuk menghitung massa tepat Bumi berdasarkan hukum gravitasi universal Newton. Alat ini menyediakan cara yang andal dan mudah untuk menghitung massa planet kita, membantu memahami konsep fisika seperti gravitasi dan pengaruhnya terhadap benda. Dapatkan perkiraan akurat massa Bumi dengan cepat dan mudah.";
const KEYWORDS =
  "massa Bumi, menghitung massa Bumi, hukum gravitasi universal, kalkulator fisika, perhitungan fisika";
const OG_URL = "https://do-calculate.com/calculator/id/earth-mass-calculator/";
const EarthMassCalculator = () => {
  const [gravity, setGravity] = useState(9.8);
  const [radius, setRadius] = useState(6.4e6);
  const [gConstant, setGConstant] = useState("");
  const [mass, setMass] = useState("");
  const [error, setError] = useState("");
  const calculateMass = (gravity, radius, gConstant) => {
    return (gravity * Math.pow(radius, 2)) / gConstant;
  };
  const handleCalculate = () => {
    try {
      const gravityValue = parseFloat(gravity);
      const radiusValue = parseFloat(radius);
      const gConstantValue = parseFloat(gConstant);
      if (gravity && radius && gConstant) {
        const calculatedMass = calculateMass(
          gravityValue,
          radiusValue,
          gConstantValue
        );
        setMass(calculatedMass.toExponential(2) + " kilogram");
        setError("");
      } else {
        throw new Error("Harap masukkan semua nilai untuk menghitung massa Bumi.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Kalkulator Massa Bumi</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator massa Bumi adalah alat canggih yang membantu Anda menghitung massa tepat
                  Bumi menggunakan hukum gravitasi universal Newton. Kalkulator ini didasarkan pada
                  serangkaian data fisika dasar seperti percepatan gravitasi Bumi, jari-jari Bumi, dan konstanta gravitasi universal. Dengan alat
                  ini, Anda dapat memperoleh perkiraan akurat massa planet kita, membantu
                  meningkatkan pemahaman Anda tentang konsep fisika seperti gravitasi dan bagaimana pengaruhnya terhadap
                  benda di luar angkasa.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Kalkulator Massa Bumi</h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Percepatan Gravitasi Bumi (a)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="9.8"
                        value={gravity}
                        onChange={(e) => setGravity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled
                      />
                      <span className="ms-2">m/s²</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Jari-jari Bumi (r)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="6.4e6"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled
                      />
                      <span className="ms-2">meter</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Konstanta Gravitasi (G)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Masukkan konstanta gravitasi"
                        value={gConstant}
                        onChange={(e) => setGConstant(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                      <span className="ms-2">m³/kg·s²</span>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { mass && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>Hasil:</p>
                        <p>Massa Bumi: {mass}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Apa itu Massa Bumi?</h3>
            </div>
            <div className="info-section-body">
              <p>
                Massa Bumi adalah jumlah materi yang terkandung dalam Bumi. Massa ini dihitung
                menggunakan hukum gravitasi universal Newton, yang menghubungkan antara massa, gaya,
                dan gravitasi.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Pentingnya Mengetahui Massa Bumi</h3>
            </div>
            <div className="info-section-body">
              <p>
                Mengetahui massa Bumi sangat penting untuk memahami banyak fenomena alam seperti
                pergerakan satelit buatan, pasang surut, dan interaksi gravitasi antara
                Bumi dan planet lain.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EarthMassCalculator;